import React from 'react';
const myths = ['Necesitas ser influencer con miles de seguidores', 'Necesitas bailar frente a la cámara o exponer a tus hijos', 'Necesitas una computadora cara o software de $200/mes', 'Necesitas experiencia en diseño o marketing digital'];
export function Problem() {
  return <section className="bg-[#0d4a45] py-16 md:py-24 relative overflow-hidden" data-id="element-321">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-72 h-72 rounded-full bg-[#e8a0a0]/10 translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-322" />
      <div className="absolute bottom-0 left-0 w-56 h-56 rounded-full bg-[#c9a84c]/10 -translate-x-1/2 translate-y-1/2 pointer-events-none" data-id="element-323" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6" data-id="element-324">
        <div className="text-center mb-10" data-id="element-325">
          <span className="font-dm text-xs font-bold tracking-widest text-[#e8a0a0] uppercase" data-id="element-326">
            El problema real
          </span>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mt-3 leading-tight" data-id="element-327">
            Te han mentido sobre cómo ganar dinero online
          </h2>
          <p className="font-dm text-white/70 text-lg mt-4 max-w-2xl mx-auto" data-id="element-328">
            El mito de la Influencer ha arruinado las oportunidades de miles de
            mamás inteligentes.
          </p>
        </div>

        {/* Myths */}
        <div className="space-y-3 mb-10" data-id="element-329">
          {myths.map(myth => <div key={myth} className="flex items-center gap-4 bg-white/5 border border-white/10 rounded-xl px-5 py-4" data-id="element-330">
              <span className="text-2xl shrink-0" data-id="element-331">❌</span>
              <p className="font-dm text-white/80 text-base" data-id="element-332">{myth}</p>
            </div>)}
        </div>

        {/* Callout */}
        <div className="border-2 border-[#c9a84c] rounded-2xl p-6 md:p-8 bg-[#c9a84c]/10 text-center" data-id="element-333">
          <p className="font-dm text-white/70 text-base mb-3" data-id="element-334">
            La verdad que nadie te dice:
          </p>
          <p className="font-playfair text-white text-xl md:text-2xl font-bold leading-snug" data-id="element-335">
            "Mientras miles intentan ser famosas, hay un grupo pequeño de madres
            inteligentes que están ganando{' '}
            <span className="text-[#e8c97a]" data-id="element-336">miles de dólares</span> moviendo
            los hilos <em data-id="element-337">detrás</em> de las marcas."
          </p>
        </div>
      </div>
    </section>;
}